<template>
  <img :class="['x-button']" v-bind="$attrs" loading="lazy" :src="wrapedSrc" @error="handleError" />
</template>
<script lang="ts" setup>
export interface IXImgProps {
  src: string;
}

const isBreak = ref(false);

const emit = defineEmits(['error']);

const wrapedSrc = computed(() => {
  let link = props.src;
  if (isBreak.value) {
    link = getFeUrl('/youyan-platform/png/home/img-placeholder-2x.png');
  }
  return transformImage(link);
});

const props = withDefaults(defineProps<IXImgProps>(), {});

const handleError = () => {
  isBreak.value = true;
  emit('error');
};
</script>
